// THE THREE ROLES, as the screen needs them — and the one rule the screen must not get
// wrong.
//
// Shared by the list and the modal rather than written twice, because the two must agree
// about which roles may be CHOSEN: a picker offering `partner` and a table that treats
// partners as read-only would be a form that saves and then fails.
import he from '../../i18n/he';

export const ROLE = { PARTNER: 'partner', SECRETARY: 'secretary', LIMITED: 'limited' };

export const roleLabel = (role) => ({
  [ROLE.PARTNER]: he.users.rolePartner,
  [ROLE.SECRETARY]: he.users.roleSecretary,
  [ROLE.LIMITED]: he.users.roleLimited,
}[role] || role);

// ⚠ `partner` IS NOT OFFERED, and the server refuses it either way.
//
// Being a partner is a business identity with a share of the profit, not a permission
// level. Two things make it the wrong shape for a dropdown: it needs a business name, a
// tax id and a VAT status that this form does not collect, and `shares.resolveShares`
// builds its default split from every active partner's `default_share_pct` — which
// defaults to 50, so a third partner would make the default total 150% and every new job
// or retainer saved with a default split would start failing.
//
// Existing partners are shown, read-only. Setting one up is a deliberate act elsewhere.
export const SELECTABLE_ROLES = [ROLE.SECRETARY, ROLE.LIMITED];

export const isPartner = (user) => user.role === ROLE.PARTNER || !!user.is_partner;
